import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUser from "../fragments/fullUserV4"

const query = gql`
  mutation DeactivateUser($userId: ID!) {
    deactivateUser(userId: $userId) {
      ...fullUser
    }
  }
  ${fullUser}
`

export const deactivateUserKey = getQueryNames(query)[0]

export default query
